import React from 'react';
import { Divider } from '@amzn/storm-ui';
import { SIDEBAR_TYPE, ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { ToolbarItemProps } from '../../store/slice';
import {
  MobileSideNavItemText,
  NonExpandableItemLink,
  StyledSvgIcon,
} from './styles';
import ExpandableMenuItem from './ExpandableMenuItem';
import { renderFlag } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { getSingleAppLink } from 'src/features/nav/utils/toolbarItemLinks';

const MobileSideNavItem: React.VFC<ToolbarItem> = (
  sideNavItem: ToolbarItem,
) => {
  if (sideNavItem.sidebarType == SIDEBAR_TYPE.DIVIDER) {
    return <Divider />;
  }
  if (!sideNavItem.sidebarGroups) {
    return null;
  }
  const item = sideNavItem as ToolbarItemProps;

  const singleAppLink = getSingleAppLink(item);
  if (singleAppLink) {
    return (
      <NonExpandableItemLink
        href={singleAppLink.link.url}
        isSelected={singleAppLink.isSelected}
        {...getTaktAttributes(singleAppLink.id, chromeComponents.NAV, {
          url: singleAppLink.link.url,
        })}
        data-ccx-e2e-id={singleAppLink.id}
      >
        <StyledSvgIcon iconPath={item.iconPath} ariaLabel={item.toolTip} />
        <MobileSideNavItemText>
          {singleAppLink.link.label}
          {renderFlag(singleAppLink, {
            isMobile: true,
          })}
        </MobileSideNavItemText>
      </NonExpandableItemLink>
    );
  } else {
    return <ExpandableMenuItem {...item} />;
  }
};

export default MobileSideNavItem;
